// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"26":"7474e047","978":"7923283e"}[chunkId] + ".chunk.css";
};